export default function getImgNameFromURL(url) {
    try {
        // Validate input
        if (typeof url !== "string" || !url.trim()) {
            throw new Error("Invalid URL string");
        }

        const path = new URL(url).pathname;
        const fileName = path.split("/").pop();

        return fileName || null;
    } catch (error) {
        console.error("Error extracting image name from URL:", error.message);
        return null; // Or return a default value like 'unknown.jpg'
    }
}
